<ng-container *ngIf="isEditable">
  <mat-select [hideSingleSelectionIndicator]="true"
    [(ngModel)]="status"
    (ngModelChange)="onStatusChange($event)"
    placeholder="{{'CONTRACTS.SELECT_STATUS' | translate}}">
    <mat-option [value]="null">{{'CONTRACTS.SELECT_STATUS' | translate}}</mat-option>
    <mat-select-trigger>
      <mat-chip [class]="statusClass">
        <div class="d-flex align-items-center">
          {{'CONTRACTS.STATUS.'+eStatus[status] | translate}}
          <mat-icon>arrow_drop_down</mat-icon>
        </div>
      </mat-chip>
    </mat-select-trigger>
    <mat-option *ngFor="let status of statusOptions"
      [value]="status">
      {{'CONTRACTS.STATUS.'+eStatus[status] | translate}}
    </mat-option>
  </mat-select>
</ng-container>

<ng-container *ngIf="!isEditable && eStatus[status]">
  <mat-chip [class]="statusClass">
    <div class="mat-chip-text">{{'CONTRACTS.STATUS.'+eStatus[status]
      | translate}}</div>
  </mat-chip>
</ng-container>

<ng-container *ngIf="!isEditable && !eStatus[status]">
  <mat-chip [class]="statusClass">{{'CONTRACTS.NO_SELECTED_STATUS' | translate}}</mat-chip>
</ng-container>